import { useEffect, useRef } from "react";

export default function NossosProdutos() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll(".np-item").forEach((item, i) => {
              setTimeout(() => item.classList.add("np-visible"), i * 100);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="produtos-iceberg" className="py-16 lg:py-20 bg-background-50 overflow-hidden" ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Image */}
          <div className="np-item opacity-0 translate-x-[-24px] transition-all duration-700 relative order-2 lg:order-2">
            <div className="relative rounded-2xl overflow-hidden scale-110">
              <img
                src="https://storage.readdy-site.link/project_files/9309375e-f328-4fba-b8d7-64d73f28a855/b7d36431-dcb4-4ce7-9eaa-347cd4278fb3_compressed_WhatsApp-Image-2026-07-08-at-14.27.51.webp"
                alt="Iceberg dos +80 produtos da Ferrarezi — benefícios visíveis e soluções estratégicas"
                className="w-full h-auto object-contain"
              />
            </div>
          </div>

          {/* Right: Content */}
          <div className="np-item opacity-0 translate-x-6 transition-all duration-700 order-1 lg:order-1">
            <div className="inline-flex items-center gap-2 mb-5">
              <span className="w-8 h-px bg-black" />
              <span className="text-black text-lg font-semibold tracking-widest uppercase">
                ecossistema completo
              </span>
            </div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-black leading-tight mb-6">
              Muito além de benefícios!
            </h2>

            <p className="text-black/70 text-lg leading-relaxed mb-10">
              Como um iceberg, a <strong>Ferrarezi</strong> vai muito além do que os olhos conseguem ver. O que você enxerga são os benefícios clássicos: saúde, odonto, vida. Mas abaixo da linha d'água, existe um ecossistema completo de <strong>proteção empresarial, seguros estratégicos e soluções de capitalização</strong>.
            </p>

            {/* CTA */}
            <button
              onClick={() => document.querySelector("#contato")?.scrollIntoView({ behavior: "smooth" })}
              className="whitespace-nowrap bg-[#FBC52D] text-black font-bold px-8 py-4 rounded-full hover:bg-[#d4a800] transition-all duration-200 cursor-pointer text-sm"
            >
              Conheça todos os produtos
            </button>
          </div>
        </div>
      </div>

      <style>{`
        .np-visible {
          opacity: 1 !important;
          transform: translateX(0) !important;
        }
      `}</style>
    </section>
  );
}